<!-- <div style="display:flex; justify-content: start; gap:0px;">
<app-icon #notesArrow [type]="'ArrowDown'" style="cursor: pointer;" (click)="toggleNotes()"></app-icon>
<h2>Notes</h2>
</div> -->
<h2>Notes</h2>

<div [hidden]="!notesExpanded">
  <div
    [hidden]="activeNoteId != undefined"
    style="
      display: flex;
      align-items: start;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #dddddd;
      gap: 12px;
    "
  >
    <div style="flex: 7">
      <app-multiline-input
        [rows]="3"
        [label]="'Add your note here'"
        [cols]="70"
        [(ngModel)]="newNoteText"
      ></app-multiline-input>
    </div>
    <div style="flex: 1">
      <input
        type="button"
        value="save"
        class="button_primary button_var_2"
        (click)="btnSave_click()"
        (keydown.enter)="btnSave_click()"
      />
    </div>
  </div>

  @for (n of notes | slice: 0 : 3; track n) {
    <div
      id="note_{{ n.id }}"
      class="note"
      (mouseover)="showEditDelete(n.id)"
      (mouseout)="hideEditDelete()"
    >
      <div
        [hidden]="activeNoteId != undefined"
        style="
          display: flex;
          align-items: start;
          margin-bottom: 10px;
          padding-bottom: 10px;
          border-bottom: 1px solid #dddddd;
          gap: 12px;
        "
      >
        <div style="flex: 7">
          <div
            style="font-style: italic; font-size: 0.9em; padding-bottom: 4px"
          >
            <span style="font-weight: 500; color: #555555">{{
              formatDate(n.updatedAt)
            }}</span>
            ({{ n.userFirst }} {{ n.userLast }})
          </div>
          <div>
            {{ n.text }}
          </div>
        </div>
        <div
          style="flex: 1"
          [hidden]="rolloverId != n.id || activeNoteId != undefined"
        >
          <app-button-input
            [icon]="'Edit'"
            (click)="btnEdit_click(n)"
            [title]="'Edit note'"
            class="button_right-spacing"
          ></app-button-input>
          <app-button-input
            [icon]="'MinusRemove'"
            (click)="btnDelete_click(n)"
            [title]="'Delete note'"
          ></app-button-input>
        </div>
      </div>
      <div [hidden]="activeNoteId != n.id">
        <div
          style="
            display: flex;
            align-items: start;
            margin-bottom: 10px;
            padding-bottom: 10px;
            border-bottom: 1px solid #dddddd;
            gap: 12px;
          "
        >
          <div style="flex: 7">
            <app-multiline-input
              [rows]="3"
              [cols]="70"
              [(ngModel)]="activeNoteText"
            ></app-multiline-input>
          </div>
          <div style="flex: 1">
            <div style="margin-bottom: 8px">
              <app-button-input
                [text]="'Save'"
                (click)="btnSaveChanges_click()"
                (keydown.enter)="btnSaveChanges_click()"
                class="button_primary button_var_2"
              ></app-button-input>
            </div>
            <div>
              <app-button-input
                [text]="'Cancel'"
                (click)="btnCancel_click()"
                (keydown.escape)="btnCancel_click()"
                class="button_primary button_var_2"
              ></app-button-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div [hidden]="notes.length < 4" style="padding-top: 8px">
    <div style="display: flex; justify-content: start; gap: 0px">
      <app-icon
        #historyArrow
        [type]="'ArrowDown'"
        style="cursor: pointer"
        (click)="toggleHistory()"
      ></app-icon>
      <div>more notes</div>
    </div>

    <div
      [hidden]="!historyExpanded"
      style="display: table; table-layout: fixed"
    >
      @for (n of notes | slice: 3; track n) {
        <div style="display: table-row">
          <div
            style="
              display: table-cell;
              font-style: italic;
              font-size: 0.9em;
              padding: 10px;
              border-bottom: 1px solid #dddddd;
            "
          >
            <span style="font-weight: 500; color: #555555">{{
              formatDate(n.updatedAt)
            }}</span
            ><br />
            ({{ n.userFirst }} {{ n.userLast }})
          </div>
          <div
            style="
              display: table-cell;
              padding-bottom: 10px;
              border-bottom: 1px solid #dddddd;
            "
          >
            : {{ n.text }}
          </div>
        </div>
      }
    </div>
  </div>
</div>
